import { ContactAndTravelerGuards } from "@apac/checkout";
import {
  CardPaymentGuards as BaseCardPaymentGuards,
  CartGuards as BaseCartGuards,
  ContactInformationGuards as BaseContactInformationGuards,
  PassengerGuards as BasePassengerGuards,
  ReviewGuards as BaseReviewGuards,
  WalletGuards as BaseWalletGuards,
  SeatGuards as BaseSeatGuards,
  getObjectKeysAsObject,
} from "@hopper-b2b/checkout";
import { ParentState } from "@hopper-b2b/checkout-types";
import type { ActivitiesMachineContext } from "../types";

const requiresPrimaryParticipantSelection = (ctx: ActivitiesMachineContext) => {
  const activityInfo = ctx[ParentState.activityInformation];
  const participantCount = activityInfo?.participantCount ?? 0;
  const travelerBookingQuestions = activityInfo?.travelerBookingQuestions;
  return participantCount > 1 && travelerBookingQuestions?.length > 0;
};

const shouldSkipPrimaryParticipantSelection = (ctx: ActivitiesMachineContext) =>
  !requiresPrimaryParticipantSelection(ctx);

export const ActivityGuards = {
  requiresPrimaryParticipantSelection,
  shouldSkipPrimaryParticipantSelection,
};

export const Guards = {
  ...BaseCartGuards,
  ...BaseContactInformationGuards,
  ...BasePassengerGuards,
  ...BaseReviewGuards,
  ...BaseCardPaymentGuards,
  ...BaseWalletGuards,
  ...BaseSeatGuards,
  ...ContactAndTravelerGuards,
  ...ActivityGuards,
};

export const GuardTypes = getObjectKeysAsObject(Guards);
